export enum CatalogType {
  RewardsNGC = 'rewardsNGC',
  Rewards = 'rewards',
}
